import React from 'react';

import AsyncDataProvider from '../../shared/components/async-data-provider';
import { StoreAppAPI } from "../../core/src/storeapp-api-client";

const storeApi = new StoreAppAPI();

export const hidePDPUpsell = (product) => {
    const { pdpConfig={} } = product;
    const { pdpDetails={} } = pdpConfig;
    const { disableUpsell } = pdpDetails;
    return disableUpsell ||
    product.categories && product.categories.indexOf('70m-W') > -1;
}

export default class PDPDataProvider extends React.Component {

    fetchData = () => {
        const { product, upsellLimit=4 } = this.props;
        const { pdpConfig={} } = product;
        const { pdpCarepackModule={} } = pdpConfig;
        const noUpsell = hidePDPUpsell(product);
        //if no sku or parent sku skip api call
        if(!product.sku || /^P_/.test(product.sku)){
            return Promise.resolve([]);
        }

        let query = {
             xsell: {},
             upsell: noUpsell ? false : {limit: upsellLimit},
             asyncComponents: true,
             features: {},
             productDetails: { keys: [`${product.sku}:compatiblePrinters`] }
        };

        if(product.prdClass === "PRT"){
            query.features = { slug: product.slug }
        }

        //Cheking if product has a parent SKU, then we dont have to make xsell call
        return storeApi.product.pdpData(product.sku, query).then((resp) => {
            let data = {}
            if (resp && resp.status == "200" && resp.data) {
               data = resp.data;
               //removing carePacks if needed
               if(pdpCarepackModule.removeCarePacks && data.xsell){
                   data.xsell = data.xsell.filter(prd=>{
                       const isCarePack = (prd.attributes && prd.attributes.pm_category) === "HP Care Pack Services";
                       return !isCarePack;
                   });
               }
            }
            return data;
        });
    }

    render(){
        const { product, children } = this.props;
        const data = [{ fetchData: this.fetchData, fields: ['xsell','bundle','upsell','oosBackup','compatiblePrinters', 'features'] }];
        return(
            <AsyncDataProvider id={product.sku} obj={product} data={data}>
            {
                (productAsyncData) => children(productAsyncData)
            }
            </AsyncDataProvider>
         );
    }
}
